import {
    AllegatoContainerDPC,
    AllegatoDPC,
    PageContainerDPC,
    LinksContainerDPC,
    LinksDPC,
    PrintButtonDPC,
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React from 'react';
import {getSlug} from "../functions/functions";
import moment from "moment";
import {prop} from "../functions/functions";
import "moment/locale/it";

export default ({data, pageContext}) => {

    const language = '/' + pageContext.lang;

    const correlazioniTypes = ['comunicato_stampa','notizia','approfondimento','pubblicazione', 'corso', 'pagina', 'sezione'];

    const fotoVideoTypes = ['galleria_foto','galleria_flickr','video'];
  
    const correlazioni = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria == null || correlazioniTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '<b>Sezione</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
      }   
    });
  
    const fotoVideo = data.node.relationships.field_correlazioni.filter(item => fotoVideoTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria === 'video' ? '<b>Video</b>' : '<b>Foto</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
      }   
    });
  
    const bandoDiGara = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'bando_di_gara').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
      }   
    });
  
    const mappe = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'mappa').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
      }   
    });
  
    const timeline = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'timeline').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
      }   
    });

    const normative = data.node.relationships.field_normative.map(item => {
        return {
            title: item.field_titolo_esteso,
            slug: getSlug(language + item.fields.slug, process.env.MINISITO_FORMAZIONE, item.relationships.field_sottodominio.name)
        }
    });

    const linkEsterni = data.node.field_link_esterni ? data.node.field_link_esterni.map(item => {
        return {
            title: item.title,
            titleLinkEsterno: "Val al sito " + item.uri,
            slug: item.uri
        }
    }) : [];

    moment.locale('it');

    return (
        <PageContainerDPC isFormazione={true}  classeAggiuntivaSubnavbar={"has-header-subnavbar-mobile-social"}
                          menuItems={pageContext.menu}
                          pageId={data.node.drupal_internal__nid}
                          slugTraduzione={data.node.relationships.field_riferimento_traduzione ? data.node.relationships.field_riferimento_traduzione.fields.slug : ''}
                          title={data.node.title}
                          env={process.env.ENV}
                          lang={pageContext.lang}
                          domain={process.env.MINISITO_FORMAZIONE_LABEL}
                          subdomainMenuItems={pageContext.menuMinisito}
                          basePathNavbar={process.env.PORTALE_URL}
                          //linkTorna={language}
                          //textTorna={'Homepage'}
                          //checkTorna={true}
                          breadcrumbItem={{
                              name: data.node.title,
                              slug: '',
                              active: true
                          }}
                          minisiti={prop}
                          immagineShare={data.node.relationships?.field_immagine_dettaglio ? process.env.MINISITO_FORMAZIONE_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_FORMAZIONE_URL + pageContext.socialImg?.relationships?.image?.localFile?.publicURL}
                          abstractShare={data.node.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
                          slug={process.env.MINISITO_FORMAZIONE_URL + '/' + pageContext.lang + data.node.fields.slug}
                          menuFooterItems={pageContext.menuFooter}
        >
            <section className="container article-card-simple">
                <div className="px-custom">
                    <article className="card-wrapper pb-0">
                        <div className="card">
                            <div className="card-body">
                                <div className="category-top">
                                    <span
                                        className="category blue">{data.node.relationships.field_ambito[0]?.name}</span>
                                    {(data.node.field_data_inizio || data.node.field_disponibile_streaming) &&
                                    <span className="data">
                                        {`${moment(data.node.field_data_inizio).format("DD MMMM YYYY")} ${data.node.field_disponibile_streaming ? data.node.field_data_inizio ? " - Disponibile in streaming" : "Disponibile in streaming" : ""}`}</span>
                                    }
                                </div>
                                <h1 className="h5 card-title">{data.node.title}</h1>
                                <div className="news-abstract"
                                     dangerouslySetInnerHTML={{__html: data.node.field_abstract ? data.node.field_abstract.processed : ''}}/>
                                <div
                                    dangerouslySetInnerHTML={{__html: data.node.body ? data.node.body.processed : ''}}/>
                            </div>
                        </div>
                    </article>

                    <section className="attachments-and-links">
                        {Array.isArray(data.node.relationships.field_allegati) &&
                        data.node.relationships.field_allegati.length > 0 &&
                        <AllegatoContainerDPC titoloSezione={'Allegati'}>
                            {
                                data.node.relationships.field_allegati.map(allegato => (
                                    <AllegatoDPC
                                        titolo={allegato.field_titolo_esteso}
                                        descrizione={allegato.relationships?.field_allegato?.description}
                                        dimension={allegato.relationships?.field_allegato?.filesize}
                                        slug={allegato.relationships?.field_allegato?.localFile?.publicURL}
                                        extension={allegato?.relationships?.field_allegato?.localFile?.extension}
                                    />
                                ))
                            }
                        </AllegatoContainerDPC>
                        }
                                    {normative && normative.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Normativa'}>
                                        <LinksDPC links={normative}/>
                                    </LinksContainerDPC>}

                                    {bandoDiGara && bandoDiGara.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Avvisi e bandi di gara'}>
                                        <LinksDPC links={bandoDiGara}/>
                                    </LinksContainerDPC>}

                                    {correlazioni && correlazioni.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Per saperne di più'}>
                                        <LinksDPC links={correlazioni}/>
                                    </LinksContainerDPC>}

                                    {fotoVideo && fotoVideo.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Foto e video'}>
                                        <LinksDPC links={fotoVideo}/>
                                    </LinksContainerDPC>}                                  

                                    {mappe && mappe.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Mappe'}>
                                        <LinksDPC links={mappe}/>
                                    </LinksContainerDPC>}

                                    {timeline && timeline.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Timeline'}>
                                        <LinksDPC links={timeline}/>
                                    </LinksContainerDPC>}

                        {linkEsterni && linkEsterni.length > 0 &&
                        <LinksContainerDPC titoloSezione={'Link esterni'}>
                            <LinksDPC links={linkEsterni}/>
                        </LinksContainerDPC>}
                    </section>

                </div>


                <PrintButtonDPC/>
            </section>
        </PageContainerDPC>
    );
};


export const query = graphql`
query($slug: String!) {
  node:nodeCorsi (fields: { slug: { eq: $slug } }) {
    drupal_internal__nid
    field_data_fine
    field_data_inizio
    field_disponibile_streaming
    field_link_esterni {
      title
      uri
    }
    body {
      processed
    }
    field_abstract {
      processed
    }
    fields {
      slug
    }
    relationships {
      field_immagine_dettaglio {
        field_alt
        field_didascalia
        field_titolo_esteso
        relationships {
          image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                fluid(maxWidth: 1100) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
        }
        }
      }
      field_ambito {
        name
      }
      field_riferimento_traduzione{
        fields{
          slug
        }
      }
      field_allegati {
        title
        field_titolo_esteso
        relationships {
          field_allegato {
            filesize
            localFile {
              publicURL
              extension
            }
            filename
          }
        }
      }
      field_correlazioni {
        ...pubblicazioneFragment
        ...notiziaFragment
        ...approfondimentoFragment
        ...normativaFragment
        ...pageFragment
        ...bandoDiGaraFragment
        ...comunicatoStampaFragment
        ...corsoFragment
        ...mappaFragment
        ...timelineFragment
        ...sezioneConAnticipazioniFragment
        ...sezioneSenzaAnticipazioniFragment
        ...elencoApprofondimentiFragment
        ...elencoGlossariFragment
        ...elencoAttualitaFragment
        ...elencoPodcastFragment
        ...elencoPubblicazioniFragment
        ...elencoNormativaFragment
        ...elencoBandiEContrattiFragment
        ...elencoFotoVideoFragment
        ...homepageVolontariatoFragment
        ...homepageRelazioniFragment
        ...homepageRischiFragment
        ...homepageNazionaleFragment
        ...homepageMappeFragment
        ...homepageGiovaniFragment
        ...homepageFormazioneFragment
        ...homepageEventiFragment
        ...homepageEmergenzeFragment
        ...homepageDocsFragment
        ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
        ...homepagePortaleFragment
        ...bollettinoCriticitaFragment
        ...bollettinoVigilanzaFragment
        ...sezioneAllertaMeteoIdroFragment
        ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
      }
      field_normative {
        ...normativaFragment
      }
    }
    title
    field_titolo_esteso
    body {
      processed
    }
    field_categoria_primaria
  }
}
`;
